import { DragAndDrop } from '../../../../components/global/DragAndDrop';
import { motion } from 'framer-motion';
import { getCoordinates } from '../ToMixed.data';
import { getBottomGapX } from "../ToMixed.data";
import {
    animationDurationToShowQuestion,
} from "../../../../config";
import React, { useState, useEffect, useRef } from 'react';
import Sound from '../../../../components/global/Sound';
import '../../../style.css'
import { Fraction } from '../../Fraction'


export const BottomPart = ({ state, answers, checkAnswer, answer, answerSound, hint }) => {
    const [i, setI] = useState('');
    const [time, setTime] = useState(0);
    const [animate, setAnimate] = useState(false);
    const [val, setVal] = useState();
    const [update, setUpdate] = useState(false);
    const soundRef = useRef();
    const soundWrongRef = useRef();
    const [type, setType] = useState(false);
    const colors = ["#34A5CF", "#DB3E50", "#7F48C3"];

    useEffect(() => {
        if (!animate) return;
        setVal('');
        setAnimate(false);
        setI('');
        setUpdate(false);
        setTime(0);
    }, [answers]);

    useEffect(() => {
        if (type) setTimeout(() => {
            setType(false);
            document.querySelector('.addingresult').style.opacity = 1;
        }, 1000);
    }, [type]);

    useEffect(() => {
        if (!hint) return;
        const id = setInterval(() => setTime(prev => prev + 1), 1000);
        return () => clearInterval(id);
    }, [time, hint]);

    return (
        <div
            className={`dropAnswers flex items-center justify-around ${state ? "bottompartIsStateHeight" : "bottompartIsNotStateHeight"} bg-white border-[2px] border-[#D2461B] md:border-[3px] xl:border-[4px] rounded-[14px] md:rounded-[16px] lg:rounded-[20px]`}>

            {answers.map((number, index) => {
                if (i === index) {
                    return <DragAndDrop
                        enableClick={true}
                        drop={'adding'}
                        animateWrong={(e) => {
                            setUpdate(index);
                            setI('');
                            if (answerSound) {
                                soundWrongRef.current.currentTime = 0;
                                soundWrongRef.current.play();
                            }
                        }}
                        key={index} numbers={[answer]} item={number} refresh={(event, type) => {
                            if (event === 'mouseup') return;
                            if (val === number) return; //prevnting multiple clicks on one element
                            setType(type);
                            setTime(0);
                            checkAnswer(event, type, number);
                            setVal(number);
                            setUpdate(false);
                            if (type) setTimeout(() => document.querySelector('.addingresult').style.opacity = 0, 200);
                            if (answerSound) {
                                soundRef.current.currentTime = 0;
                                soundRef.current.play();
                            }
                        }}>
                        <motion.div
                            style={{
                                transform: type && val === number && `translate(${getCoordinates()[0]}px,${getCoordinates()[1]}px)`,
                                transition: `transform ${0.2}s linear`
                            }}
                            className={`relative answer ${val === number && !type ? 'opacity-0' : 'opacity-100'} z-[4000] cursor-pointer`}
                        >

                            <div
                                style={{ backgroundColor: colors[index] }}
                                className={`
                                h-[42px]
                                w-[78px]
                                xs:w-[104px]
                                xs:h-[54px]
                                sm:w-[108px] sm:h-[47px]
                                    ${state ? "md:w-[114px] md:h-[49px] lg:w-[150px] lg:h-[69px] xl:w-[200px] xl:h-[82px]" : "md:w-[150px] md:h-[66px] lg:w-[188px] lg:h-[81px] xl:w-[232px] xl:h-[96px]"}
                                    rounded-[7px]
                                    lg:rounded-[10px]
                                    font-bigfatScript
                                    flex
                                    items-center
                                    justify-center
                                    text-white
                                `}
                            >
                            <Fraction value={number} state={state} mixed={true}/>
                            </div>
                            {answer === number && time >= 10 && time % 2 === 0 && <div className="bg-[url('/backGrounds/hint.svg')] bg-[position:50%_50%] bg-contain bg-no-repeat absolute w-[50px] h-[50px] top-[50%] z-[100]"></div>}
                        </motion.div>
                    </DragAndDrop>
                } else {
                    return <motion.div
                        key={index} className={`relative z-[4000] cursor-pointer`}
                        animate={{ y: animate ? [0, 0] : [(index + 1) * 100, 0], x: update === index ? [-2, 0, 2, 0] : [0, 0] }}
                        transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
                        onPointerEnter={(e) => {
                            setI(index);
                            setAnimate(true);
                            setUpdate(false);
                        }}
                    >
                        <div
                                style={{ backgroundColor: colors[index] }}
                                className={`
                                    h-[42px]
                                    w-[78px]
                                    xs:w-[104px]
                                    xs:h-[54px]
                                    sm:w-[108px] sm:h-[47px]
                                    ${state ? "md:w-[114px] md:h-[49px] lg:w-[150px] lg:h-[69px] xl:w-[200px] xl:h-[82px]" : "md:w-[150px] md:h-[66px] lg:w-[188px] lg:h-[81px] xl:w-[232px] xl:h-[96px]"}
                                    rounded-[7px]
                                    lg:rounded-[10px]
                                    font-bigfatScript
                                    flex
                                    items-center
                                    justify-center
                                    text-white
                                `}
                            >
                            <Fraction value={number} state={state} mixed={true}/>
                        </div>
                        {hint && answer === number && time >= 10 && time % 2 === 0 && <div className="bg-[url('/backGrounds/hint.svg')] bg-[position:50%_50%] bg-contain bg-no-repeat absolute w-[50px] h-[50px] top-[50%] z-[100]"></div>}
                    </motion.div>
                }
            })}
            <Sound ref={soundRef} url={"/backGrounds/right_answer.wav"} loop={false} />
            <Sound ref={soundWrongRef} url={"/backGrounds/wrong_answer.wav"} loop={false} />
        </div>
    )
}